import { render, staticRenderFns } from "./BackofficeProcedimentoConfiguracaoOperadora.vue?vue&type=template&id=f5f4fd16"
import script from "./BackofficeProcedimentoConfiguracaoOperadora.vue?vue&type=script&lang=ts"
export * from "./BackofficeProcedimentoConfiguracaoOperadora.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports